import { styled } from "styled-components";

export const AuthorDetailsContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`;

export const AuthorInfo = styled.p`
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
`;

export const BlogCardContainer = styled.div`
  margin-top: 20px;
`;
